"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../../styles/variables");

var _excluded = ["color", "size", "outline", "disabled", "children", "block", "loading", "type"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var sizes = {
  xs: (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-width: 96px;\n    height: 32px;\n    font-size: 10px;\n  "]))),
  sm: (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    min-width: 110px;\n    height: 36px;\n    font-size: 12px;\n  "]))),
  md: (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    min-width: 140px;\n    height: 42px;\n    font-size: 14px;\n  "]))),
  lg: (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    min-width: 140px;\n    height: 48px;\n    font-size: 16px;\n  "])))
};
var variants = {
  block: (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    width: 100%;\n    display: flex;\n  "]))),
  outline: (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n\n    &:hover {\n      background-color: ", ";\n    }\n\n    &:disabled {\n      background-color: ", ";\n      border: none;\n      color: ", ";\n    }\n  "])), function (_ref) {
    var color = _ref.color;
    return color === "swan" ? _variables.colors.swan : _variables.colors.ghost;
  }, function (_ref2) {
    var color = _ref2.color;
    return color === "swan" ? _variables.colors.hare : _variables.colors[color];
  }, function (_ref3) {
    var color = _ref3.color;
    return color === "hare" || color === "swan" ? _variables.colors.wolf : _variables.colors[color];
  }, function (_ref4) {
    var color = _ref4.color;
    return color === "swan" ? _variables.colors.hare : _variables.colors.swan;
  }, _variables.colors.hare, _variables.colors.ghost)
};

var StyledButton = _styledComponents["default"].button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-family: IranSansX, sans-serif;\n  border-radius: 10px;\n  background-color: ", ";\n  border: none;\n  color: #fff;\n  outline: none !important;\n  cursor: pointer;\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.05);\n  padding-right: 10px;\n  padding-left: 10px;\n  display: flex;\n  min-width: 110px;\n  height: 36px;\n  font-size: 12px;\n  justify-content: center;\n  align-items: center;\n\n  &:active {\n    -webkit-tap-highlight-color: transparent;\n    outline: none;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    background-color: ", ";\n    border: none;\n    color: ", ";\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref5) {
  var color = _ref5.color;
  return _variables.colors[color];
}, function (_ref6) {
  var color = _ref6.color;
  return _variables.colors[color + "Hover"];
}, _variables.colors.hare, _variables.colors.ghost, function (_ref7) {
  var size = _ref7.size;
  return sizes[size];
}, function (_ref8) {
  var block = _ref8.block;
  return block && variants.block;
}, function (_ref9) {
  var outline = _ref9.outline;
  return outline && variants.outline;
});

var Ellipsis = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  animation: ellipsis 1000ms linear infinite;\n  background-color: ", ";\n  border-radius: 100%;\n  box-shadow: -1em 0 0 #fff , 1em 0 0 #fff;\n  display: block;\n  height: 7px;\n  width: 7px;\n  animation-name: ", ";\n  },\n"])), _variables.colors.ghost, function (_ref10) {
  var outline = _ref10.outline;
  return outline ? ellipsisOutline : ellipsis;
});

var ellipsisOutline = (0, _styledComponents.keyframes)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  0% {\n    background-color: transparent;\n    box-shadow: -1em 0 0 transparent, 1em 0 0 transparent;\n  }\n  20% {\n    background-color: transparent;\n    box-shadow: -1em 0 0 ", ", 1em 0 0 transparent;\n  }\n  40% {\n    background-color: ", ";\n    box-shadow: -1em 0 0 ", ", 1em 0 0 transparent;\n  }\n  60% {\n    background-color: ", ";\n    box-shadow: -1em 0 0 transparent, 1em 0 0 ", ";\n  }\n  80% {\n    background-color: transparent;\n    box-shadow: -1em 0 0 transparent, 1em 0 0 ", ";\n  }\n  100% {\n    background-color: transparent;\n    box-shadow: -1em 0 0 transparent, 1em 0 0 transparent;\n  }\n"])), _variables.colors.ghost, _variables.colors.whale, _variables.colors.whale, _variables.colors.ghost, _variables.colors.ghost, _variables.colors.ghost);
var ellipsis = (0, _styledComponents.keyframes)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  0% {\n    background-color: transparent;\n    box-shadow: -1em 0 0 transparent, 1em 0 0 transparent;\n  }\n  20% {\n    background-color: transparent;\n    box-shadow: -1em 0 0 ", ", 1em 0 0 transparent;\n  }\n  40% {\n    background-color: ", ";\n    box-shadow: -1em 0 0 ", ", 1em 0 0 transparent;\n  }\n  60% {\n    background-color: ", ";\n    box-shadow: -1em 0 0 transparent, 1em 0 0 ", ";\n  }\n  80% {\n    background-color: transparent;\n    box-shadow: -1em 0 0 transparent, 1em 0 0 ", ";\n  }\n  100% {\n    background-color: transparent;\n    box-shadow: -1em 0 0 transparent, 1em 0 0 transparent;\n  }\n"])), _variables.colors.whale, _variables.colors.whale, _variables.colors.whale, _variables.colors.whale, _variables.colors.whale, _variables.colors.whale);

var Button = function Button(props) {
  var color = props.color,
      size = props.size,
      outline = props.outline,
      disabled = props.disabled,
      children = props.children,
      block = props.block,
      loading = props.loading,
      type = props.type,
      htmlAttributes = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(StyledButton, _extends({
    color: color,
    size: size,
    block: block,
    outline: outline,
    disabled: disabled,
    type: type
  }, htmlAttributes), loading ? /*#__PURE__*/_react["default"].createElement(Ellipsis, null) : children);
};

exports.Button = Button;
Button.propTypes = {
  /** Any React Node to be displayed inside the button */
  children: _propTypes["default"].node.isRequired,

  /** Button color */
  color: _propTypes["default"].oneOf(["father", "mother", "hare", "swan"]),

  /** Button size */
  size: _propTypes["default"].oneOf(["lg", "md", "sm", "xs"]),

  /** Enable outline buttons */
  outline: _propTypes["default"].bool,

  /** Enable disable buttons */
  disabled: _propTypes["default"].bool,

  /** Enable full width buttons */
  block: _propTypes["default"].bool,

  /** Loading */
  loading: _propTypes["default"].bool,

  /** Button type */
  type: _propTypes["default"].oneOf(["button", "submit", "reset"])
};
Button.defaultProps = {
  color: "father",
  size: "md",
  outline: false,
  block: false,
  loading: false,
  type: "button"
};